import service from '@/store/services/users-service';

const state = {
  list: {},
  user: {},
  meta: {},
  students: {},
  teachers: {},
  deletedList:{}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_STUDENT_LIST: (state, students) => {
    state.students = students;
  },
  SET_TEACHER_LIST: (state, teachers) => {
    state.teachers = teachers;
  },
  SET_DELETED_LIST: (state, deletedList) => {
    state.deletedList = deletedList;
  },
  SET_RESOURCE: (state, user) => {
    state.user = user;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list}) => {
        commit('SET_LIST', list);
      });
  },

  students({commit, dispatch}, params) {
    return service.list(params)
      .then(({list}) => {
        commit('SET_STUDENT_LIST', list);
      });
  },

  teachers({commit, dispatch}, params) {
    return service.list(params)
      .then(({list}) => {
        commit('SET_TEACHER_LIST', list);
      });
  },

  deleted({commit, dispatch}, params) {
    return service.list(params)
      .then(({list}) => {
        commit('SET_DELETED_LIST', list);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((user) => { commit('SET_RESOURCE', user); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((user) => { commit('SET_RESOURCE', user); });
  },

  addAsAdmin({commit, dispatch}, params) {
    return service.addAsAdmin(params)
      .then((user) => { commit('SET_RESOURCE', user); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((user) => { commit('SET_RESOURCE', user); });
  },

  updatePassword({commit, dispatch}, params) {
    return service.updatePassword(params)
      .then((user) => { commit('SET_RESOURCE', user); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

  enable({commit, dispatch}, params) {
    return service.enable(params);
  },

  resetPassword({commit, dispatch}, params) {
    return service.resetPassword(params);
  }
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  user: state => state.user,
  students: state => state.students,
  teachers: state => state.teachers,
  deletedList: state => state.deletedList,
};

const users = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default users;
